import { render, staticRenderFns } from "./unitArticle.vue?vue&type=template&id=64bf0df7"
import script from "./unitArticle.vue?vue&type=script&lang=js"
export * from "./unitArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports